import '@mdi/font/css/materialdesignicons.css' // Ensure you are using css-loader
import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
Vue.use(Vuetify)


export default new Vuetify({
    theme: {

        themes: {

            light: {
                primary: '#2196F3',
                secondary: '#ff9800',
                accent: '#009688',
                error: '#D50000',
                info: '#607d8b',
                success: '#4CAF50',
                warning: '#FFC107',
                kassa: '#c2ecff',
            }

        },
    },

     icons: {
    iconfont: 'mdi', // default - only for display purposes
  },

})
